import { render, staticRenderFns } from "./BlankoElementComp.vue?vue&type=template&id=4324c943&scoped=true&"
import script from "./BlankoElementComp.vue?vue&type=script&lang=ts&"
export * from "./BlankoElementComp.vue?vue&type=script&lang=ts&"
import style0 from "./BlankoElementComp.vue?vue&type=style&index=0&id=4324c943&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324c943",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VBtn,VIcon,VMenu})
